import React from 'react'
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CautionImg from '../assets/caution_img.svg'
import NonDigitalImg from '../assets/non_digital_img.svg'
import { VEHICLE_RECALL, CAR_ARRIVED, PARKING_AND_IMAGE_CAPTURE, CAR_COLLECTION } from '../utils/shareData';

const AdditionalInfo = ({ bookingDetails, currentActivity, isDigitalProcess, parkingName, otp }) => {
    const RecallInfo = () => {
        const theme = useTheme();
        return (
            <>
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", backgroundColor: "#FFFEE7", width: "100%", borderBottom: "1px solid #EFEFEF", padding: "8px 34px", borderRadius: "4px 4px 0px 0px" }}>
                    <img src={CautionImg} alt='Caution' width={13} height={13} />
                    <Box sx={{ color: theme.palette.darkBrown.main, fontSize: "12px", fontWeight: theme.typography.fontWeightSemibold, marginLeft: "10px" }}>Please reach at valet booth before arrival time.</Box>
                </Box>
                <Box sx={{ marginBottom: "15px", textAlign: "center", backgroundColor: "#FFFEE7", width: "100%", padding: "8px 64px", borderRadius: "0px 0px 4px 4px" }}>
                    <Box sx={{ color: theme.palette.darkBrown.main, fontSize: "12px", fontWeight: theme.typography.fontWeightSemibold, marginLeft: "10px" }}>It takes approximately {bookingDetails && bookingDetails.recall_time ? bookingDetails.recall_time : "15"} minutes after you recall your vehicle.</Box>
                </Box>
                {otp &&
                    <Box sx={{ marginBottom: "15px", padding: "16px", border: "1px solid #EEEEEE", width: "100%", borderRadius: "4px" }}>
                        <Box sx={{ color: theme.palette.darkBrown.main, fontSize: "12px", fontWeight: theme.typography.fontWeightSemibold, marginBottom: "8px" }}>Share this OTP with the Operator.</Box>
                        <Box sx={{ color: "#18CC69", fontSize: "28px", fontWeight: theme.typography.fontWeightSemibold, letterSpacing: "0.16px" }}>{otp}</Box>
                    </Box>
                }
            </>
        )
    }

    const ArrivalInfo = () => {
        const theme = useTheme();
        return (
            <>
                <Box sx={{ marginBottom: "15px", display: "flex", justifyContent: "flex-start", alignItems: "center", backgroundColor: "#FFFEE7", width: "100%", padding: "8px 8px", borderRadius: "4px" }}>
                    <img src={CautionImg} alt='Caution' width={13} height={13} />
                    <Box sx={{ color: theme.palette.darkBrown.main, fontSize: "12px", fontWeight: theme.typography.fontWeightSemibold, marginLeft: "10px" }}>{`Our valet is ready for you. Please head to the ${parkingName} valet booth.`}</Box>
                </Box>
                {otp &&
                    <Box sx={{ marginBottom: "15px", padding: "16px", border: "1px solid #EEEEEE", width: "100%", borderRadius: "4px" }}>
                        <Box sx={{ color: theme.palette.darkBrown.main, fontSize: "12px", fontWeight: theme.typography.fontWeightSemibold, marginBottom: "8px" }}>Share this OTP with the Operator.</Box>
                        <Box sx={{ color: "#18CC69", fontSize: "28px", fontWeight: theme.typography.fontWeightSemibold, letterSpacing: "0.16px" }}>{otp}</Box>
                    </Box>
                }
            </>
        )
    }

    const NonDigitalRecallInfo = () => {
        const theme = useTheme();
        return (
            <>
                <Box sx={{ marginBottom: "15px", display: "flex", justifyContent: "flex-start", alignItems: "center", backgroundColor: "#FFFEE7", width: "100%", padding: "8px 8px", borderRadius: "4px" }}>
                    <img src={NonDigitalImg} alt='Caution' width={20} height={20} />
                    <Box sx={{ color: theme.palette.darkBrown.main, fontSize: "14px", fontWeight: theme.typography.fontWeightSemibold, marginLeft: "10px" }}>To recall your car, please present the QR code which you got from the team at the valet booth in person. Our valet team will assist you from there.</Box>
                </Box>
                {otp &&
                    <Box sx={{ marginBottom: "15px", padding: "16px", border: "1px solid #EEEEEE", width: "100%", borderRadius: "4px" }}>
                        <Box sx={{ color: theme.palette.darkBrown.main, fontSize: "12px", fontWeight: theme.typography.fontWeightSemibold, marginBottom: "8px" }}>Share this OTP with the Operator.</Box>
                        <Box sx={{ color: "#18CC69", fontSize: "28px", fontWeight: theme.typography.fontWeightSemibold, letterSpacing: "0.16px" }}>{otp}</Box>
                    </Box>
                }
            </>
        )
    }

    const OTP = () => {
        const theme = useTheme();
        if(!otp) return null
        return (
            <>
                    <Box sx={{ marginBottom: "15px", padding: "16px", border: "1px solid #EEEEEE", width: "100%", borderRadius: "4px" }}>
                        <Box sx={{ color: theme.palette.darkBrown.main, fontSize: "12px", fontWeight: theme.typography.fontWeightSemibold, marginBottom: "8px" }}>Share this OTP with the Operator.</Box>
                        <Box sx={{ color: "#18CC69", fontSize: "28px", fontWeight: theme.typography.fontWeightSemibold, letterSpacing: "0.16px" }}>{otp}</Box>
                    </Box>
            </>
        )
    }

    if (!isDigitalProcess && currentActivity.name === PARKING_AND_IMAGE_CAPTURE) return NonDigitalRecallInfo()
    else if(currentActivity.name === PARKING_AND_IMAGE_CAPTURE || currentActivity.name === CAR_COLLECTION) return OTP()
    else if (currentActivity.name === VEHICLE_RECALL) return RecallInfo()
    else if (currentActivity.name === CAR_ARRIVED) return ArrivalInfo()
    else return null
}

export default AdditionalInfo